function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#8BCEFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.8248 5.96541L12.0395 4.85608C11.792 4.70286 11.4722 4.8806 11.4722 5.17111V7.0919C11.4722 7.22061 11.5384 7.33951 11.6474 7.40693L12.7355 8.08356L13.1705 8.35323C13.4082 8.50155 13.304 8.86806 13.0234 8.86806H11.8422C11.6376 8.86806 11.471 9.03477 11.471 9.23947V11.1983C11.471 12.0575 10.7321 12.7464 9.85725 12.6643C9.09511 12.592 8.5278 11.9215 8.5278 11.1554V9.58146V8.87051V6.28044C8.5278 6.15173 8.46163 6.03283 8.35258 5.96541L6.56732 4.85608C6.3198 4.70286 6 4.8806 6 5.17233V7.09313C6 7.22184 6.06617 7.34074 6.17522 7.40816L7.26329 8.08479L7.69827 8.35446C7.93598 8.50278 7.83183 8.86929 7.55123 8.86929H6.37127C6.16664 8.87051 6 9.03599 6 9.24192V11.1125C6 13.2894 7.70317 15.133 9.87931 15.198C12.14 15.2654 14 13.4451 14 11.1983V8.87051V6.28044C14 6.15296 13.9338 6.03283 13.8248 5.96541Z",
  fill: "white"
});

var SvgUbdiRound = function SvgUbdiRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUbdiRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ubdiRound.f3cc9753.svg";
export { ForwardRef as ReactComponent };